export const common = {
  // Header
  'header.home': 'Home',
  'header.about': 'About',
  'header.faq': 'FAQ',
  'header.contact': 'Contact',
  'header.signIn': 'Sign In',
  'header.getStarted': 'Get Started',

  // Footer
  'footer.tagline': 'Elevate Your Financial Future',
  'footer.description': 'Secure, reliable, and innovative payment solutions for individuals and businesses worldwide.',
  'footer.quickLinks': 'Quick Links',
  'footer.services': 'Services',
  'footer.contact': 'Contact Us',
  'footer.address': '789 Summit Avenue, San Francisco, CA 94102',
  'footer.email': 'support@pinnaclepayments.com',
  'footer.phone': '+1 (415) 555-1234',
  'footer.copyright': '© 2024 Pinnacle Payments. All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',

  // Home Page
  'home.hero.title': 'Elevate Your Financial Future',
  'home.hero.subtitle': 'Experience seamless banking with cutting-edge technology. Manage your wealth, invest smartly, and achieve your financial goals with Pinnacle Payments.',
  'home.hero.cta': 'Get Started Today',
  'home.hero.learn': 'Learn More',

  'home.stats.users': 'Active Users',
  'home.stats.countries': 'Countries Served',
  'home.stats.transactions': 'Transactions Processed',
  'home.stats.support': '24/7 Support',

  'home.services.title': 'Our Premium Services',
  'home.services.subtitle': 'Comprehensive financial solutions tailored to your needs',

  'home.services.banking.title': 'Digital Banking',
  'home.services.banking.desc': 'Modern banking at your fingertips with instant transfers, bill payments, and real-time balance tracking.',

  'home.services.investment.title': 'Investment Solutions',
  'home.services.investment.desc': 'Grow your wealth with our curated investment portfolios and expert financial guidance.',

  'home.services.loans.title': 'Flexible Loans',
  'home.services.loans.desc': 'Quick approval personal and business loans with competitive rates and flexible repayment terms.',

  'home.services.cards.title': 'Virtual Cards',
  'home.services.cards.desc': 'Secure virtual debit and credit cards for safe online shopping and international transactions.',

  'home.features.title': 'Why Choose Pinnacle Payments',
  'home.features.subtitle': 'Experience banking excellence with industry-leading features',

  'home.features.security.title': 'Bank-Grade Security',
  'home.features.security.desc': 'Your funds are protected with military-grade encryption and multi-factor authentication.',

  'home.features.instant.title': 'Instant Transfers',
  'home.features.instant.desc': 'Send and receive money instantly across 180+ countries with zero delays.',

  'home.features.support.title': '24/7 Expert Support',
  'home.features.support.desc': 'Our dedicated team is always available to assist you with any questions or concerns.',

  'home.features.rates.title': 'Competitive Rates',
  'home.features.rates.desc': 'Enjoy the best exchange rates and lowest fees in the industry for all transactions.',

  'home.plans.title': 'Financial Growth Plans',
  'home.plans.subtitle': 'Choose the perfect plan to achieve your financial goals',

  'home.plans.dps.title': 'Deposit Pension Scheme',
  'home.plans.dps.rate': 'Annual Return',
  'home.plans.dps.term': 'Flexible Terms',
  'home.plans.dps.feature1': 'Monthly deposit options',
  'home.plans.dps.feature2': 'Guaranteed returns',
  'home.plans.dps.feature3': 'Tax benefits',
  'home.plans.dps.feature4': 'Early withdrawal option',
  'home.plans.dps.cta': 'Start Saving',

  'home.plans.fdr.title': 'Fixed Deposit Receipt',
  'home.plans.fdr.rate': 'Interest Rate',
  'home.plans.fdr.term': 'Lock-in Period',
  'home.plans.fdr.feature1': 'Guaranteed high returns',
  'home.plans.fdr.feature2': 'Flexible tenure options',
  'home.plans.fdr.feature3': 'Loan against FDR',
  'home.plans.fdr.feature4': 'Auto-renewal available',
  'home.plans.fdr.cta': 'Invest Now',

  'home.plans.loan.title': 'Personal Loans',
  'home.plans.loan.rate': 'Starting From',
  'home.plans.loan.term': 'Repayment Period',
  'home.plans.loan.feature1': 'Quick approval in 24 hours',
  'home.plans.loan.feature2': 'No hidden charges',
  'home.plans.loan.feature3': 'Flexible EMI options',
  'home.plans.loan.feature4': 'Minimal documentation',
  'home.plans.loan.cta': 'Apply Now',

  'home.testimonials.title': 'What Our Clients Say',
  'home.testimonials.subtitle': 'Join thousands of satisfied customers worldwide',

  'home.cta.title': 'Ready to Transform Your Financial Future?',
  'home.cta.subtitle': 'Join millions of users who trust Pinnacle Payments for their financial needs',
  'home.cta.button': 'Create Your Account',

  // About Page
  'about.hero.title': 'About Pinnacle Payments',
  'about.hero.subtitle': 'Leading the future of digital finance since 2010',

  'about.story.title': 'Our Story',
  'about.story.content': 'Founded in 2010, Pinnacle Payments emerged from a vision to revolutionize the financial services industry. We recognized that traditional banking was failing to meet the needs of a rapidly evolving digital world. Our founders, a team of fintech pioneers and banking veterans, set out to create a platform that combines cutting-edge technology with personalized service. Today, we serve over 8 million customers across 180 countries, processing billions in transactions annually while maintaining our commitment to security, innovation, and customer satisfaction.',

  'about.mission.title': 'Our Mission',
  'about.mission.content': 'To empower individuals and businesses worldwide with accessible, secure, and innovative financial solutions that enable them to achieve their goals and build lasting prosperity.',

  'about.vision.title': 'Our Vision',
  'about.vision.content': 'To become the world\'s most trusted digital financial platform, setting new standards for excellence, security, and customer experience in the fintech industry.',

  'about.stats.customers': 'Happy Customers',
  'about.stats.transactions': 'Transactions Processed',
  'about.stats.countries': 'Countries Worldwide',
  'about.stats.rating': 'Customer Rating',

  'about.values.title': 'Our Core Values',
  'about.values.security.title': 'Security First',
  'about.values.security.desc': 'We prioritize the safety of your funds and data above all else.',
  'about.values.innovation.title': 'Innovation',
  'about.values.innovation.desc': 'Continuously evolving to provide cutting-edge financial solutions.',
  'about.values.transparency.title': 'Transparency',
  'about.values.transparency.desc': 'Clear communication and honest practices in everything we do.',
  'about.values.excellence.title': 'Excellence',
  'about.values.excellence.desc': 'Delivering exceptional service and results for our customers.',

  'about.team.title': 'Meet Our Leadership Team',
  'about.team.subtitle': 'Experienced professionals driving innovation in fintech',

  // FAQ Page
  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Find answers to common questions about our services',

  'faq.general': 'General',
  'faq.account': 'Account',
  'faq.security': 'Security',
  'faq.payments': 'Payments',

  // Contact Page
  'contact.title': 'Get in Touch',
  'contact.subtitle': 'We\'re here to help with any questions or concerns',

  'contact.info.title': 'Contact Information',
  'contact.info.address': 'Visit Us',
  'contact.info.email': 'Email Us',
  'contact.info.phone': 'Call Us',
  'contact.info.hours': 'Business Hours',
  'contact.info.hoursValue': 'Monday - Friday: 8:00 AM - 7:00 PM PST',

  'contact.form.title': 'Send Us a Message',
  'contact.form.name': 'Full Name',
  'contact.form.email': 'Email Address',
  'contact.form.subject': 'Subject',
  'contact.form.message': 'Message',
  'contact.form.send': 'Send Message',

  'contact.map.title': 'Our Location',
};

export default common;